// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js","976":"c16184b3"}[chunkId] || chunkId) + "-" + {"678":"5296cf98e984735f6769","883":"754733843c7aa03a3dd0","954":"fc3749778d7b696f73de","976":"e0bae986acf6d48a8a31"}[chunkId] + ".js";
};